export default "__VITE_ASSET__BexDvp9B__"